import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ValueWithRandom } from "../../../ValueWithRandom";
export var MovePathDelay = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(MovePathDelay, _ValueWithRandom);

  function MovePathDelay() {
    _classCallCheck(this, MovePathDelay);

    return _possibleConstructorReturn(this, _getPrototypeOf(MovePathDelay).call(this));
  }

  return MovePathDelay;
}(ValueWithRandom);